import * as React from 'react';
  
export const MijnFNVPageContext = React.createContext(
    {
        routeState : { },
        search : "",
        pathParam : "",
        pathname : ""
    }
);